import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { TefComsBaseSelect } from '@src/testing/components/TefComsBaseSelect.js';

interface SpId {
  id: string,
  description: string;
}

//
// renders a simple <select> with all available service providers fetched from the core API
//
@customElement('tef-coms-spid-select')
export class TefComsSpidSelect extends TefComsBaseSelect {
  data: SpId[];

  async connectedCallback() {
    this.data = await this.api<SpId[]>('service/serviceproviders');
    super.connectedCallback();
  }

  render() {
    const serviceProviderOptions = this.data.map((serviceProvider) => html`
      <option value="${serviceProvider.id}" ?selected=${this.selected === serviceProvider.id}>${serviceProvider.id} (${serviceProvider.description})</option>
    `);

    return html`
      <select name="spId" id="spid-select" class="form-select">
        <option value="">Select a spId</option>
        ${serviceProviderOptions}
      </select>
    `;
  }
}
